export default function capitalizeFirst(value) {
    if (!value) return '';
    return value
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }